<template>
<div class="row">
    <pre @click="clickPre" id="text">
backgroundGradient: {
	type: 'linear',
	colors: [
		'{{ color1 }}', '{{color2}}'
	],
	startPoint: {
		x: '{{ startX }}',
		y: '{{ startY }}'
	},
	endPoint: {
		x: '{{ endX }}',
		y: '{{ endY }}'
	},
	backFillStart: true
}
</pre>
    <div class="gradient" :style="style"></div>
</div>
</template>

<script>
export default {
    name: 'CodeBlock',
    props: {
        color1: String,
        color2: String,
        flip: Boolean,
        horizontal: Boolean
    },
    data() {
        return {
            startX: "0%",
            endX: "0%",
            startY: "100%",
            endY: "0%",
        }
    },
    watch: {
        flip: function() {
            this.checkSettings();
        },
        horizontal: function() {
            this.checkSettings();
        }
    },
    computed: {
        style() {
			console.log("style");
            var deg = "0deg"
            var col1 = this.color1;
            var col2 = this.color2;
            if (this.flip) {
                col1 = this.color2;
                col2 = this.color1;
            }
            if (this.horizontal) {
                deg = "-90deg"
            }
            return 'background: linear-gradient(' + deg + ', ' + col2 + ' 0%, ' + col1 + ' 100%);';
        }
    },
    methods: {
        clickPre() {
            selectText("text");
        },
        checkSettings() {
            if (this.horizontal) {
                this.startY = "0%"
                this.endY = "0%"
                this.startX = this.flip ? "100%" : "0%"
                this.endX = this.flip ? "0%" : "100%"
            } else {
                this.startY = this.flip ? "100%" : "0%"
                this.endY = this.flip ? "0%" : "100%"
                this.startX = "0%"
                this.endX = "0%"
            }
        }
    }
}

function selectText(node) {
    node = document.getElementById(node);

    if (document.body.createTextRange) {
        const range = document.body.createTextRange();
        range.moveToElementText(node);
        range.select();
    } else if (window.getSelection) {
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(node);
        selection.removeAllRanges();
        selection.addRange(range);
    } else {
        console.warn("Could not select text in node: Unsupported browser.");
    }
}
</script>

<style scoped>
.row {
    display: flex;
}

pre {
    border: 1px solid #000;
    padding: 20px;
	font-size: 18px;
	font-family: 'Times New Roman', Times, serif;
}

.gradient {
    margin-left: 20px;
    width: 100px;
    display: inline-block;

}
</style>
